import React, { useEffect, useState } from 'react'

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'

import {  showDepartments, updateDepartments } from '../../../../MyApi/sb/departments'

import PageHeader from '../../../../Components/UI/PageHeader'
import LoadingSpinner from '../../../../Components/UI/spinner'
import EditDepartment from '../../../../Components/sb/departments/departmentsUpdate/AddBranch'
  

const  DepartmentUpdate = () => {
const {id}= useParams()
const selectedlang = localStorage.getItem("i18nextLng")
const [selectedCodeLang ,setSelectedCodeLang] =useState(selectedlang)
const showDepartmentQuery = useQuery(["showdepartment",id ,selectedCodeLang] ,()=> showDepartments(id ,selectedCodeLang))
const departments = showDepartmentQuery.data?.data ||{}
const [name ,setName]= useState(departments.company)
const [sb_branch_id ,setBranchId]=useState(departments.branch_id)
const [sb_employe_id , setEmployId] =useState(departments.employe_id ? departments.employe_id :null)
const [sb_company_id , setCompanyId]=useState(departments.company_id)
const [description, setDescription] =useState(departments.description)
const [active ,setActive]=useState(departments.active)


useEffect(()=>{
    showDepartmentQuery.refetch()
},[selectedCodeLang,showDepartmentQuery.refetch])
 const mutation = useMutation(["updateDepartment",id , selectedCodeLang] , (postData)=>updateDepartments(postData ,id ,selectedCodeLang) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
    },
    onError :(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 useEffect(()=>{
   if(showDepartmentQuery.isSuccess){
      setName(departments.company)
      setEmployId(departments.employe_id)
      setBranchId(departments.branch_id)
      setCompanyId(departments.company_id)
      setDescription(departments.description)
      setActive(departments.active)
   }
  
 },[showDepartmentQuery.data])

 const handlePostRequest =()=>{
    mutation.mutate({
        name,     
        sb_branch_id ,
        sb_employe_id,
        sb_company_id,
        active, 
        description,
        lang_code: selectedCodeLang

    })
 }
 const isDisabled= ()=>{
    return false

 }
 const onSelectChange =(e)=>{
    setSelectedCodeLang(e.target.value)
 }
 if(showDepartmentQuery.isLoading){
   return <LoadingSpinner/>
}
 if(!showDepartmentQuery.data){
    return <div>no data available</div>
 }

  return ( 

    <div>
        <PageHeader title="Edit Department" showSelect onSelectChange={onSelectChange} showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditDepartment sb_employe_id={sb_employe_id}  sb_company_id={sb_company_id}  active={active} sb_branch_id={sb_branch_id}  name={name} setName={setName}   setActive={setActive}  description={description} setDescription={setDescription}  setEmployId={setEmployId}  setBranchId={setBranchId}   setCompanyId={setCompanyId}   />
    </div>
  )
}

export default DepartmentUpdate